import { render, staticRenderFns } from "./AdminNoveltiesTableSelected.vue?vue&type=template&id=573ba411"
import script from "./AdminNoveltiesTableSelected.vue?vue&type=script&lang=js"
export * from "./AdminNoveltiesTableSelected.vue?vue&type=script&lang=js"
import style0 from "./AdminNoveltiesTableSelected.vue?vue&type=style&index=0&id=573ba411&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports